import {propertyTypes} from "@/services/properties";

const properties = {

  prodottoProperty: {
    code: "1a",
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tariffeProperty: {
    code: "1b",
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatoProperty: {
    code: "1c",
    name: "Codice prodotti collegato",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: "2",
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: "3",
    name: "Canale",
    description: "",
    order: 4,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: "4",
    name: "Distributori",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  modDistribuzioneProperty: {
    code: "5",
    name: "Modalità di distribuzione",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: "6",
    name: "Mercato",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  destinatariProperty: {
    code: "7",
    name: "Destinatari",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  targetMarketProperty: {
    code: "8",
    name: "Target Market",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  descProdottoProperty: {
    code: "9",
    name: "Descrizione prodotto",
    description: "",
    order: 10,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  lineaBusinessProperty: {
    code: "10",
    name: "Linea di business",
    description: "",
    order: 11,
    value: "Veicoli",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  veicoliProperty: {
    code: "11",
    name: "Veicoli",
    description: "",
    order: 12,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: "12",
    name: "Prodotto in commercio",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: "13",
    name: "Inizio commercializzazione",
    description: "",
    order: 14,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: "14",
    name: "Fine commercializzazione",
    description: "",
    order: 15,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: "15",
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 16,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoAssicurazioneProperty: {
    code: "16",
    name: "Tipologia di assicurazione",
    description: "",
    order: 17,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  durataProperty: {
    code: "17",
    name: "Durata contrattuale",
    description: "",
    order: 18,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tacitoRinnovoProperty: {
    code: "18",
    name: "Tacito rinnovo",
    description: "",
    order: 19,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combGaranzieTipologiaProperty: {
    code: "19",
    name: "Combinazione garanzie - Tipologia",
    description: "",
    order: 20,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combGaranzieDescProperty: {
    code: "20",
    name: "Combinazione garanzie - Descrizione",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioTipologiaProperty: {
    code: "21",
    name: "Premio - Tipologia",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioDescProperty: {
    code: "22",
    name: "Premio - Descrizione",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  frazPremioProperty: {
    code: "23",
    name: "Frazionamento del premio",
    description: "",
    order: 24,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  interessiFrazProperty: {
    code: "24",
    name: "Interessi di frazionamento",
    description: "",
    order: 25,
    value: "",
    values: [],
    valueDescription: "",
    frazionamento: {
      mensile: "", mensileSign: "",
      bimestrale: "", bimestraleSign: "",
      trimestrale: "", trimestraleSign: "",
      quadrimestrale: "", quadrimestraleSign: "",
      semestrale: "", semestraleSign: "",
    },
    type: propertyTypes.FRAZIONAMENTO,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  retrDistrProperty: {
    code: "25",
    name: "Retrocessione alla distribuzione",
    description: "",
    order: 26,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  retrDistrSpecificheProperty: {
    code: "26",
    name: "Retrocessione alla distribuzione - Specifiche",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  rischiProperty: {
    code: "27",
    name: "Rischi assicurati",
    description: "",
    order: 28,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  rcTarifProperty: {
    code: "28",
    name: "Responsabilità civile - Forme tariffarie",
    description: "",
    order: 29,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcGuidaProperty: {
    code: "29",
    name: "Responsabilità civile - Forme di guida",
    description: "",
    order: 30,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  guidaLiberaProperty: {
    code: "30",
    name: "Forma di guida Libera",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  guidaEspertaProperty: {
    code: "31",
    name: "Forma di guida Esperta",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  guidaEsclusivaProperty: {
    code: "32",
    name: "Forma di guida Esclusiva",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcSatellitareProperty: {
    code: "33",
    name: "Responsabilità civile - Dispositivo satellitare",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  satOutsourcingProperty: {
    code: "34",
    name: "Dispositivo satellitare - Outsourcing",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  satProprietaProperty: {
    code: "35",
    name: "Dispositivo satellitare - Proprietà",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  satServiziProperty: {
    code: "36",
    name: "Dispositivo satellitare - Servizi",
    description: "",
    order: 37,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  satScontiProperty: {
    code: "37",
    name: "Dispositivo satellitare - Sconti",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcRivalsaProperty: {
    code: "38",
    name: "Responsabilità civile - Rivalsa",
    description: "",
    order: 39,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaEbrezzaProperty: {
    code: "39",
    name: "Rivalsa per guida in stato di ebbrezza",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaStupefacentiProperty: {
    code: "40",
    name: "Rivalsa per guida sotto effetto di stupefacenti",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaTerziProperty: {
    code: "41",
    name: "Rivalsa per danni subiti da terzi trasportati se il trasporto non è effettuato in conformità di legge",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaPatenteProperty: {
    code: "42",
    name: "Rivalsa per guida con patente scaduta",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaMinoriProperty: {
    code: "43",
    name: "Rivalsa per Responsabilità Civile per fatto di figli minori",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaRevisioneProperty: {
    code: "44a",
    name: "Rivalsa per veicolo non sottoposto a revisione",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaNeopatentatiProperty: {
    code: "44b",
    name: "Rivalsa per guida di neopatentati con patente da meno di un anno e veicolo di potenza eccedente il consentito",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rivalsaAcquistoProperty: {
    code: "45",
    name: "Rivalsa - formula d'acquisto",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcMeritoProperty: {
    code: "46",
    name: "Responsabilità civile - Mantenimento della classe di merito in caso di sinistro",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcSpecificaProperty: {
    code: "47",
    name: "Responsabilità civile - Risarcimento in forma specifica",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcSospensioneProperty: {
    code: "48a",
    name: "Responsabilità civile - Sospensione del contratto",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  rcRicorsoProperty: {
    code: "48b",
    name: "Responsabilità civile - Ricorso terzi",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Responsabilità civile",
    sectionIndex: 2
  },
  ifIncendioProperty: {
    code: "49",
    name: "Incendio e Furto - Eventi compresi Incendio",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifFurtoProperty: {
    code: "50",
    name: "Incendio e Furto - Eventi compresi Furto",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifVincoliProperty: {
    code: "51",
    name: "Incendio e Furto - Vincoli/Peculiarità",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifTotaleProperty: {
    code: "52",
    name: "Incendio e Furto - Valore a nuovo per danno totale",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifParzialeProperty: {
    code: "53",
    name: "Incendio e Furto - Valore a nuovo per danno parziale",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifProporzionaleProperty: {
    code: "54",
    name: "Incendio e Furto - Regola proporzionale",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  ifTerziProperty: {
    code: "55",
    name: "Incendio e Furto - Ricorso terzi",
    description: "",
    order: 56,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Incendio e Furto",
    sectionIndex: 3
  },
  kaskoCollisioneProperty: {
    code: "56",
    name: "Kasko / Collisione - Tipologia",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collPlafDenominazioneProperty: {
    code: "57",
    name: "Collisione plafonata - Denominazione",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collPlafEventiProperty: {
    code: "58",
    name: "Collisione plafonata - Eventi compresi",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collPlafVincoliProperty: {
    code: "59",
    name: "Collisione plafonata - Vincoli/Peculiarità",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collPlafMassimaliProperty: {
    code: "60",
    name: "Collisione plafonata - Massimali",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collPlafFranchigieProperty: {
    code: "61",
    name: "Collisione plafonata - Franchigie/Scoperti",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collEventiProperty: {
    code: "62",
    name: "Collisione - Eventi compresi",
    description: "",
    order: 63,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collVincoliProperty: {
    code: "63",
    name: "Collisione - Vincoli/Peculiarità",
    description: "",
    order: 64,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collTotaleProperty: {
    code: "64",
    name: "Collisione - Valore a nuovo per danno totale",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collParzialeProperty: {
    code: "65",
    name: "Collisione - Valore a nuovo per danno parziale",
    description: "",
    order: 66,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  collFranchigieProperty: {
    code: "66",
    name: "Collisione - Franchigie/Scoperti",
    description: "",
    order: 67,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  kaskoEventiProperty: {
    code: "67",
    name: "Kasko completa - Eventi compresi",
    description: "",
    order: 68,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  kaskoVincoliProperty: {
    code: "68",
    name: "Kasko completa - Vincoli/Peculiarità",
    description: "",
    order: 69,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  kaskoTotaleProperty: {
    code: "69",
    name: "Kasko completa - Valore a nuovo per danno totale",
    description: "",
    order: 70,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  kaskoParzialeProperty: {
    code: "70",
    name: "Kasko completa - Valore a nuovo per danno parziale",
    description: "",
    order: 71,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  kaskoFranchigieProperty: {
    code: "71",
    name: "Kasko completa - Franchigie/Scoperti",
    description: "",
    order: 72,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Kasko / Collisione",
    sectionIndex: 4
  },
  attiVandaliciEventiProperty: {
    code: "72",
    name: "Atti vandalici - Eventi compresi",
    description: "",
    order: 73,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Atti vandalici",
    sectionIndex: 5
  },
  attiVandaliciVincoliProperty: {
    code: "73",
    name: "Atti vandalici - Vincoli/Peculiarità",
    description: "",
    order: 74,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Atti vandalici",
    sectionIndex: 5
  },
  attiVandaliciFranchigieProperty: {
    code: "74",
    name: "Atti vandalici - Franchigie/Scoperti",
    description: "",
    order: 75,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Atti vandalici",
    sectionIndex: 5
  },
  eventiNaturaliEventiProperty: {
    code: "75",
    name: "Eventi naturali - Eventi compresi",
    description: "",
    order: 76,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi naturali",
    sectionIndex: 6
  },
  eventiNaturaliVincoliProperty: {
    code: "76",
    name: "Eventi naturali - Vincoli/Peculiarità",
    description: "",
    order: 77,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi naturali",
    sectionIndex: 6
  },
  eventiNaturaliFranchigieProperty: {
    code: "77",
    name: "Eventi naturali - Franchigie/Scoperti",
    description: "",
    order: 78,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi naturali",
    sectionIndex: 6
  },
  eventiSociopoliticiEventiProperty: {
    code: "78",
    name: "Eventi sociopolitici - Eventi compresi",
    description: "",
    order: 79,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi sociopolitici",
    sectionIndex: 6
  },
  eventiSociopoliticiVincoliProperty: {
    code: "79",
    name: "Eventi sociopolitici - Vincoli/Peculiarità",
    description: "",
    order: 80,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi sociopolitici",
    sectionIndex: 6
  },
  eventiSociopoliticiFranchigieProperty: {
    code: "80",
    name: "Eventi sociopolitici - Franchigie/Scoperti",
    description: "",
    order: 81,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Eventi sociopolitici",
    sectionIndex: 6
  },
  cristalliEventiProperty: {
    code: "81",
    name: "Cristalli - Eventi compresi",
    description: "",
    order: 82,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Cristalli",
    sectionIndex: 7
  },
  cristalliVincoliProperty: {
    code: "82",
    name: "Cristalli - Vincoli/Peculiarità",
    description: "",
    order: 83,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Cristalli",
    sectionIndex: 7
  },
  cristalliMassimaliProperty: {
    code: "83",
    name: "Cristalli - Massimali",
    description: "",
    order: 84,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Cristalli",
    sectionIndex: 7
  },
  cristalliFranchigieProperty: {
    code: "84",
    name: "Cristalli - Franchigie/Scoperti",
    description: "",
    order: 85,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Cristalli",
    sectionIndex: 7
  },
  assistenzaTipologiaProperty: {
    code: "85",
    name: "Assistenza - Tipologia",
    description: "",
    order: 86,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Assistenza",
    sectionIndex: 8
  },
  assistenzaFormeProperty: {
    code: "86",
    name: "Assistenza - Forme",
    description: "",
    order: 87,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Assistenza",
    sectionIndex: 8
  },
  assistenzaMassimaliProperty: {
    code: "87",
    name: "Assistenza - Massimali",
    description: "",
    order: 88,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Assistenza",
    sectionIndex: 8
  },
  assistenzaOutsourcingProperty: {
    code: "88",
    name: "Assistenza - Outsourcing",
    description: "",
    order: 89,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Assistenza",
    sectionIndex: 8
  },
  tutelaLegaleTipologiaProperty: {
    code: "91",
    name: "Tutela legale - Tipologia",
    description: "",
    order: 92,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Tutela legale",
    sectionIndex: 9
  },
  tutelaLegaleFormeProperty: {
    code: "92",
    name: "Tutela legale - Forme",
    description: "",
    order: 93,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Tutela legale",
    sectionIndex: 9
  },
  tutelaLegaleMassimaliProperty: {
    code: "93",
    name: "Tutela legale - Massimali",
    description: "",
    order: 94,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Tutela legale",
    sectionIndex: 9
  },
  tutelaLegaleOutsourcingProperty: {
    code: "94",
    name: "Tutela legale - Outsourcing",
    description: "",
    order: 95,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Tutela legale",
    sectionIndex: 9
  },
  infConducenteTipologiaProperty: {
    code: "95",
    name: "Infortuni del conducente - Tipologia",
    description: "",
    order: 96,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infConducenteLimitiProperty: {
    code: "96",
    name: "Infortuni del conducente - Limiti di età",
    description: "",
    order: 97,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMorteVincoliProperty: {
    code: "97",
    name: "Morte da infortunio - Vincoli/Peculiarità",
    description: "",
    order: 98,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMorteMassimaliProperty: {
    code: "98",
    name: "Morte da infortunio - Massimali",
    description: "",
    order: 99,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMorteFranchigieProperty: {
    code: "99",
    name: "Morte da infortunio - Franchigie/Scoperti",
    description: "",
    order: 100,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infInvTabellaProperty: {
    code: "100",
    name: "Invalidità permanente da infortunio - Tabella",
    description: "",
    order: 101,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infInvVincoliProperty: {
    code: "101",
    name: "Invalidità permanente da infortunio - Vincoli/Peculiarità",
    description: "",
    order: 102,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infInvMassimaliProperty: {
    code: "102",
    name: "Invalidità permanente da infortunio - Massimali",
    description: "",
    order: 103,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infInvFranchigieProperty: {
    code: "103",
    name: "Invalidità permanente da infortunio - Franchigie/Scoperti",
    description: "",
    order: 104,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infInvSopravalutazioneProperty: {
    code: "104",
    name: "Invalidità permanente da infortunio - Sopravalutazione",
    description: "",
    order: 105,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infDiariaVincoliProperty: {
    code: "105",
    name: "Diaria da ricovero da infortunio - Vincoli/Peculiarità",
    description: "",
    order: 106,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infDiariaMassimaliProperty: {
    code: "106",
    name: "Diaria da ricovero da infortunio - Massimali",
    description: "",
    order: 107,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infDiariaFranchigieProperty: {
    code: "107",
    name: "Diaria da ricovero da infortunio - Franchigie/Scoperti",
    description: "",
    order: 108,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseGenericheVincoliProperty: {
    code: "108",
    name: "Rimborso spese mediche generiche - Vincoli/Peculiarità",
    description: "",
    order: 109,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseGenericheMassimaliProperty: {
    code: "109",
    name: "Rimborso spese mediche generiche - Massimali",
    description: "",
    order: 110,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseGenericheFranchigieProperty: {
    code: "110",
    name: "Rimborso spese mediche generiche - Franchigie/Scoperti",
    description: "",
    order: 111,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseInterventoVincoliProperty: {
    code: "111",
    name: "Rimborso spese mediche per grande intervento chirurgico - Vincoli/Peculiarità",
    description: "",
    order: 112,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseInterventoMassimaliProperty: {
    code: "112",
    name: "Rimborso spese mediche per grande intervento chirurgico - Massimali",
    description: "",
    order: 113,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseInterventoFranchigieProperty: {
    code: "113",
    name: "Rimborso spese mediche per grande intervento chirurgico - Franchigie/Scoperti",
    description: "",
    order: 114,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseRicoveroVincoliProperty: {
    code: "114",
    name: "Rimborso spese mediche per ricovero o intervento chirurgico in genere - Vincoli/Peculiarità",
    description: "",
    order: 115,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseRicoveroMassimaliProperty: {
    code: "115",
    name: "Rimborso spese mediche per ricovero o intervento chirurgico in genere - Massimali",
    description: "",
    order: 116,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  rimbSpeseRicoveroFranchigieProperty: {
    code: "116",
    name: "Rimborso spese mediche per ricovero o intervento chirurgico in genere - Franchigie/Scoperti",
    description: "",
    order: 117,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMobilitaVincoliProperty: {
    code: "117",
    name: "Infortuni in mobilità - Vincoli/Peculiarità",
    description: "",
    order: 118,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMobilitaMassimaliProperty: {
    code: "118",
    name: "Infortuni in mobilità - Massimali",
    description: "",
    order: 119,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infMobilitaFranchigieProperty: {
    code: "119",
    name: "Infortuni in mobilità - Franchigie/Scoperti",
    description: "",
    order: 120,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  inabilitaVincoliProperty: {
    code: "120",
    name: "Inabilità temporanea - Vincoli/Peculiarità",
    description: "",
    order: 121,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  inabilitaMassimaliProperty: {
    code: "121",
    name: "Inabilità temporanea - Massimali",
    description: "",
    order: 122,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  inabilitaFranchigieProperty: {
    code: "122",
    name: "Inabilità temporanea - Franchigie/Scoperti",
    description: "",
    order: 123,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  infConducenteAltroProperty: {
    code: "123",
    name: "Infortuni del conducente - Altro",
    description: "",
    order: 124,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Infortuni del conducente",
    sectionIndex: 9
  },
  altreGaranzieProperty: {
    code: "124a",
    name: "Altre garanzie",
    description: "",
    order: 125,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Altre garanzie",
    sectionIndex: 10
  },
  innovazioneProperty: {
    code: "124b",
    name: "Innovazione",
    description: "",
    order: 125,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Altre garanzie",
    sectionIndex: 10
  },
  noteProperty: {
    code: "125",
    name: "Note",
    description: "",
    order: 126,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 11
  },
};

export default properties;
